import { User } from "firebase/auth"
import { makeAutoObservable, runInAction } from "mobx"
import { FIRESTORE_COLLECTIONS } from "../enums"
import { auth } from "../firebaseApp"
import { IParticipatedEventItem, IUser, IUserCollectionItem } from "../interfaces"
import FirebaseMapper from "../mappers/FirebaseMapper"
import FirebaseService from "../services/FirebaseService"
import Firestore from "../services/FirestoreService"

class AuthStore {
	public isLoading = false
	public isLoggedIn = false
	public user: IUser | null = null
	public notifications: Notification[] = []
	public error: Error | null = null

	get showQuestionnairePrompt(): boolean {
		// const questionnaireNotification = this.notifications.find((n) => {
		// 	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		// 	const { type } = n.request.content.data as unknown as INotification
		// 	return type === NotificationType.Questionnaire
		// })

		// return questionnaireNotification !== undefined
		return true
	}

	get badgesFromEvents(): IParticipatedEventItem[] | undefined {
		if (!this.user) {
			return
		}

		return this.user.events
	}
	constructor() {
		makeAutoObservable(this)

		// Handle persistent login
		auth.onAuthStateChanged((user) => {
			if (!this.isLoggedIn && user) {
				this.signIn(user)
			}

			if (this.isLoggedIn && !user) {
				this.signOut()
			}
		})
	}

	public async signIn(persistentFirebaseUser?: User): Promise<void> {
		this.isLoggedIn = false
		this.user = null
		this.isLoading = true
		this.error = null

		let googleUser: User | null = persistentFirebaseUser ?? null
		let user: IUser | null = null
		let error: Error | null = null

		// Log into Firebase
		try {
			if (!googleUser) {
				googleUser = await FirebaseService.signInWithGoogle()

				if (!googleUser) {
					throw new Error("Could not sign in with Firebase")
				}
			}

			user = FirebaseMapper.mapGoogleUserToUser(googleUser)
		} catch (err) {
			error = err as Error
		}

		if (!googleUser) {
			return
		}

		// Get or create user object in Firestore
		try {
			const userFromDb = await Firestore.get<IUserCollectionItem>(FIRESTORE_COLLECTIONS.USER_COLLECTION, googleUser.uid)

			if (userFromDb && user) {
				user.events = userFromDb.events
			}
		} catch (err) {
			await Firestore.create<IUserCollectionItem>(
				FIRESTORE_COLLECTIONS.USER_COLLECTION,
				{
					email: googleUser.email ?? "",
					events: [],
					userId: googleUser.uid,
					displayName: googleUser.displayName ?? "",
				},
				googleUser.uid,
			)
		}

		runInAction(() => {
			this.isLoggedIn = !!user
			this.user = user
			this.error = error
			this.isLoading = false
		})
	}

	public async signOut(): Promise<void> {
		if (!auth.currentUser) {
			return
		}

		this.isLoading = true
		this.error = null

		let error: Error | null = null

		try {
			await FirebaseService.logout()
		} catch (err) {
			error = err as Error
		}

		runInAction(() => {
			this.isLoggedIn = false
			this.user = null
			this.error = error
			this.isLoading = false
		})
	}

	addNotification(notification: Notification) {
		this.notifications.push(notification)
	}

	clearNotifications() {
		this.notifications = []
	}
}

export default new AuthStore()
